<template>
  <div class="modal">
    <div class="modal-content" v-if="props.header == 'otpLimit'">
      <header class="modal-header">
        <h3 class="ampTitle">
          {{ t("ccOnBoarding.otp.limit") }}
        </h3>
      </header>
      <section class="modal-card-body">
        <div class="frame-36260">
          <div
            class="you-ve-reached-the-maximum-limit-for-otp-requests-please-continue-to-the-next-step"
          >
            {{ t("ccOnBoarding.otp.description") }}
          </div>
        </div>
      </section>
      <footer class="modal-footer">
        <div class="close-button">
          <button
            class="btn-close1"
            aria-label="close"
            @click="emit('closeModal')"
          >
            <p class="text">{{ t("ccOnBoarding.otp.continue") }}</p>
          </button>
        </div>
      </footer>
    </div>

    <div class="modal-content" v-if="props.header == 'suppOtpLimit'">
      <header class="modal-header">
        <h3 class="ampTitle">
          {{ t("ccOnBoarding.otp.limit") }}
        </h3>
      </header>
      <section class="modal-card-body">
        <div class="frame-36260">
          <div
            class="you-ve-reached-the-maximum-limit-for-otp-requests-please-continue-to-the-next-step"
          >
            {{ t("ccOnBoarding.otp.suppMaxLimit") }}
          </div>
        </div>
      </section>
      <footer class="modal-footer">
        <div class="close-button">
          <button
            class="btn-close1"
            aria-label="close"
            @click="emit('closeModal')"
          >
            <p class="text">{{ t("ccOnBoarding.otp.continue") }}</p>
          </button>
        </div>
      </footer>
    </div>

    <div
      :class="[deviceType, 'modal-content-usagePolicy']"
      v-if="props.header == 'usagePolicy'"
    >
      <header class="modal-header">
        <h3 class="ampTitle">
          {{ t("ccOnBoarding.basicInformation.policy") }}
        </h3>
      </header>
      <section :class="[deviceType, 'modal-card-body-usagePolicy']">
        <div class="frame-36260">
          <div class="usage_policy" style="max-height: 400px; overflow-y: auto">
            {{ t("ccOnBoarding.basicInformation.usagePolicy") }}
          </div>
        </div>
      </section>
      <footer class="modal-footer">
        <div class="close-button">
          <button
            class="btn-close1"
            aria-label="close"
            @click="emit('closeModal')"
          >
            <p class="text">{{ t("ccOnBoarding.otp.okay") }}</p>
          </button>
        </div>
      </footer>
    </div>

    <div
      :class="[deviceType, 'modal-content-terms']"
      v-if="props.header == 'termsAndCondition'"
    >
      <header class="modal-header-terms">
        <div class="popup-sign">
          <svg
            class="group-208"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 20L8.33825e-08 0"
              stroke="white"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M0 20L20 0"
              stroke="white"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <h3 class="ampTitle-terms">
          {{ t("ccOnBoarding.termsCondition.unsuccessfulHeader") }}
        </h3>
        <div
          class="top-navigation-24"
          aria-label="close"
          @click="emit('closeModal')"
        >
          <svg
            class="group-70"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.884033 0.668945L16.384 16.1689"
              stroke="black"
              stroke-opacity="0.87"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M16.116 0.668945L0.615967 16.1689"
              stroke="black"
              stroke-opacity="0.87"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </header>
      <section class="modal-card-body">
        <div class="frame-36260">
          <div class="unsuccessful-content">
            {{
              t("ccOnBoarding.termsCondition.unsuccessfulContent1")
            }}customer.service@aeoncredit.com.my
            {{ t("ccOnBoarding.termsCondition.unsuccessfulContent2") }}
          </div>
        </div>

        <!-- <iframe
          :src="source1"
          width="600"
          height="400"
          frameborder="0"
        ></iframe> -->
      </section>
      <footer class="modal-footer-terms">
        <div class="close-button">
          <button class="btn-close1" aria-label="close" @click="emit('submit')">
            <p class="text">{{ t("ccOnBoarding.termsCondition.submit") }}</p>
          </button>
        </div>
      </footer>
    </div>
    <div
      v-if="props.header == 'uploadDocJump'"
      :class="[deviceType, 'modal-content-uploadDocConfirm']"
    >
      <ConfirmUploadDocumentPopUp
        :header="props.header"
        :popup="props.popup"
        @close-modal="uploadDocCloseModal"
        @submit="submitUploadDoc"
      >
      </ConfirmUploadDocumentPopUp>
    </div>

    <div class="modal-content" v-if="props.header == 'timeOut'">
      <SessionTimeOutPopUp
        :header="props.header"
        :popup="props.popup"
        @endSession="timeOutCloseModal"
        @confirmation="confirmation"
        @stayOnPage="stayOnPage"
        @changeApplication="changeApplication"
        :countDown="props.countDown"
        :type="props.type"
        :webFormRequestId="props.webFormRequestId"
        :changeApplicationFlag="props.changeApplicationFlag"
        :pfTimeoutFlag="pfTimeoutFlag"
        @jumpStep="jumpStep"
        @stopCountDown="stopCountDown"
        :token="props.token"
        @tokenSessionTimeOut="tokenSessionTimeOut"
        @changePFTimeoutFlag="changePFTimeoutFlag"
      >
      </SessionTimeOutPopUp>
    </div>

    <div class="modal-content" v-if="props.header == 'startApplication'">
      <StartApplicationPopOut
        :header="props.header"
        :popup="props.popup"
        @endSession="uploadDocCloseModal"
        :applicationType="props.applicationType"
        :totalTime="props.totalTime"
      >
      </StartApplicationPopOut>
    </div>

    <div class="modal-content" v-if="props.header == 'confirmation'">
      <SessionEndingConfirmationPopOut
        :header="props.header"
        :popup="props.popup"
        @endSession="uploadDocCloseModal"
        @stayOnPage="stayOnPage"
        :confirmationTime="props.confirmationTime"
      >
      </SessionEndingConfirmationPopOut>
    </div>

    <div class="modal-content" v-if="props.header == 'sessionEnd'">
      <SessionEndPopOut
        :header="props.header"
        :popup="props.popup"
        @endSession="uploadDocCloseModal"
      >
      </SessionEndPopOut>
    </div>

    <div class="modal-content" v-if="props.header == 'draftFound'">
      <DraftFound
        @resumeApplication="resumeApplication"
        @startNewApplication="startNewApplication"
      >
      </DraftFound>
    </div>
  </div>
</template>
<script setup lang="ts">
import Constants from "@/constants/constants";
import { ref, computed, onMounted, watch } from "vue";
import i18n from "@/plugin/i18n";
import { deviceDetect } from "mobile-device-detect";
import ConfirmUploadDocumentPopUp from "./ConfirmUploadDocumentPopUp.vue";
import SessionTimeOutPopUp from "./SessionTimeOutPopUp.vue";
import StartApplicationPopOut from "./StartApplicationPopOut.vue";
import SessionEndingConfirmationPopOut from "./SessionEndingConfirmationPopOut.vue";
import SessionEndPopOut from "./SessionEndPopOut.vue";
import DraftFound from "./DraftFound.vue";

const emit = defineEmits([
  "jumpStep",
  "closeModal",
  "submit",
  "stayOnPage",
  "closeTimeOutModal",
  "confirmation",
  "changeApplication",
  "stopCountDown",
  "resumeApplication",
  "startNewApplication",
  "tokenSessionTimeOut",
  "changePFTimeoutFlag",
]);

const deviceType = ref("");

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

const { t } = i18n.global;
const props = defineProps({
  pdfUrlLink: {
    type: String,
  },
  declaration: {
    type: Array as () => string[],
  },
  type: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  header: {
    type: String,
    required: true,
  },
  popup: {
    type: Boolean,
    default: false,
  },
  countDown: {
    type: Number,
  },
  applicationType: {
    type: String,
  },
  totalTime: {
    type: Number,
  },
  webFormRequestId: {
    type: String,
  },
  changeApplicationFlag: {
    type: Boolean,
    default: false,
  },
  token: {
    type: String,
    default: "",
  },
  confirmationTime: {
    type: Number,
  },
  pfTimeoutFlag: {
    type: Boolean,
    default: false,
  },
});
const modal = ref(null);

const uploadDocCloseModal = () => {
  emit("closeModal");
};

const timeOutCloseModal = () => {
  emit("closeTimeOutModal");
};

const confirmation = () => {
  emit("confirmation");
};

const submitUploadDoc = () => {
  emit("submit");
};

const stayOnPage = () => {
  emit("stayOnPage");
};

const changeApplication = () => {
  emit("changeApplication");
};

const stopCountDown = () => {
  emit("stopCountDown");
};

const resumeApplication = () => {
  emit("resumeApplication");
};

const startNewApplication = () => {
  emit("startNewApplication");
};

const tokenSessionTimeOut = () => {
  emit("tokenSessionTimeOut");
};

const changePFTimeoutFlag = () => {
  emit("changePFTimeoutFlag");
};

const jumpStep = (value: Number, name: string, page: string) => {
  emit("jumpStep", value, name, page);
};
</script>

<style scoped>
.delete {
  text-align: end;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999999;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  padding: 0 20px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  overflow: hidden;
}

.modal-content {
  background-color: white;
  border-radius: 5px;
  max-width: 500px;
  max-height: 100%;
  /* overflow-y: auto; */
  position: relative;
}

.modal-content-usagePolicy {
  background-color: white;
  border-radius: 5px;
  max-width: 60%;
  /* max-height: 60%;
  overflow-y: auto; */
  position: relative;
}

.modal-content-uploadDocConfirm {
  background-color: white;
  border-radius: 5px;
  width: 80%;
  max-width: 60%;
  /* max-height: 60%;
  overflow-y: auto; */
  position: relative;
}

.modal-content-terms {
  background-color: white;
  border-radius: 5px;
  max-width: 60%;
  max-height: 100%;
  /* overflow-y: hidden; */
  position: relative;
}

.modal-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 1000;
}

.modal-header-terms {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 1000;
  text-align: center;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.btn-close1 {
  position: -webkit-sticky;
  position: sticky;
  z-index: 1001; /* Set a higher z-index to ensure it's above the PDF content and header */
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 20px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.close-button {
  display: flex;
  width: 117px;
  margin-right: 4px;
}

.pdf-container {
  width: 100%;
}

.modal-card-body {
  border-bottom: 1px solid #dbdfea;
  border-top: 1px solid #dbdfea;
}

.modal-card-body-usagePolicy {
  border-bottom: 1px solid #dbdfea;
  border-top: 1px solid #dbdfea;
}

/* 
.modal-card {
margin-top: 10px;
max-height: calc(100vh - 160px);
overflow: auto;
position: relative;
width: calc(100% - 2em);
} */
@media screen and (min-width: 300px) {
  .modal-card {
    margin: 0 auto;
    max-height: calc(100vh - 40px);
    width: 640px;
  }
}

.ampTitle {
  color: var(--black-high-87, rgba(0, 0, 0, 0.87));
  font-family: Outfit;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  margin-bottom: 0;
}

.ampTitle-terms {
  color: var(--Primary-Active, #ac2887);
  font-family: Outfit;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  margin-bottom: 0;
}

.frame-36260,
.frame-36260 * {
  box-sizing: border-box;
}
.frame-36260 {
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.you-ve-reached-the-maximum-limit-for-otp-requests-please-continue-to-the-next-step {
  color: var(--web-black-medium, #757575);
  text-align: left;
  font-family: var(--body-regular-font-family, "Outfit-Regular", sans-serif);
  font-size: var(--body-regular-font-size, 16px);
  line-height: var(--body-regular-line-height, 130%);
  font-weight: var(--body-regular-font-weight, 400);
  position: relative;
  flex: 1;
}

.usage_policy {
  color: var(--Web-Black-Medium, #757575);
  /* Body (Regular) */
  font-family: Outfit;
  /* font-size: 16px; */
  font-size: 14px;
  font-style: normal;
  /* font-weight: 400; */
  font-weight: 400;
  line-height: 130%; /* 20.8px */
}

.unsuccessful-content {
  color: var(--web-black-medium, #757575);
  text-align: left;
  font-family: var(--body-regular-font-family, "Outfit-Regular", sans-serif);
  font-size: var(--body-regular-font-size, 16px);
  line-height: var(--body-regular-line-height, 130%);
  font-weight: var(--body-regular-font-weight, 400);
  position: relative;
  flex: 1;
  text-align: center;
}

.modal-footer {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: white;
}

.modal-footer-terms {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

.popup-sign,
.popup-sign * {
  box-sizing: border-box;
}
.popup-sign {
  background: var(--alert-negative, #df0029);
  border-radius: 60px;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  position: relative;
  margin: auto;
}
.group-208 {
  height: auto;
  position: absolute;
  left: calc(50% - 10px);
  top: calc(50% - 10px);
  overflow: visible;
}

.top-navigation-24 {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  position: absolute;
  right: 3%;
  top: 24px;
  overflow: hidden;
}

.modal-content-terms:is(.Mobile) {
  max-width: 100%;
}

.modal-card-body-usagePolicy:is(.Mobile) {
  overflow-y: scroll;
}

@media screen and (max-width: 600px) {
  .modal-card-body-usagePolicy:is(.Mobile) {
    height: 400px;
  }
}

@media screen and (max-width: 768px) {
  .modal-content-usagePolicy:is(.Mobile) {
    max-width: 100%;
  }
  .modal-content-uploadDocConfirm:is(.Mobile) {
    max-width: 100%;
  }
}
</style>
